import { useMemo } from "react";
import useSWR from "swr";
import { toDomainService } from "../domain/influencerService";
import fetcher from "./fetcher";

const baseEndpoint = "/api/influencer-services";

export default function useInfluencerServices(influencerId) {
  const { data, error, mutate } = useSWR(
    influencerId ? `${baseEndpoint}/${influencerId}` : null,
    fetcher,
  );

  const services = useMemo(() => {
    if (!data?.services || !Array.isArray(data.services)) {
      return [];
    }

    return data.services.map(toDomainService);
  }, [data]);

  return {
    services,
    isLoading: !data && !error,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
